import { useRef } from "react";
import { useSelector } from "react-redux";
import { Footer } from "src/Modules/MainMenu";
import LandingContent from "src/Modules/MainMenu/components/LandingContent/LandingContent";
import LandingNavBar from "src/Modules/MainMenu/components/NavBar/LandingNavBar";
import { RootState } from "src/store";
import LandingHero from "./components/LandingHero";

export default function LandingPage() {
  const isIntegerated = useSelector((state: RootState) => state.auth.isIntegrated);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative flex min-h-screen w-full flex-col">
      <div className="flex min-h-svh h-svh flex-col">
        <div className="w-full border-b border-border-minimal h-min">
          <LandingNavBar />
        </div>
        <div className="flex flex-1 items-center h-full select-none">
          <LandingHero contentRef={contentRef} />
        </div>
      </div>
      <div ref={contentRef} className="relative flex flex-1 flex-col md:px-5 lg:px-10 p-2">
        <LandingContent />
      </div>
      <div className="bg-background-minimal flex items-center justify-center text-xs font-thin">{!isIntegerated && <Footer />}</div>
    </div>
  );
}
